

<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/服务支持banner.png" alt="">
        <div class="newsPageList news home-box flex-row">
            <div class="productWrap w12">
                <div class="peoduct-left">
                    <div class="page-title page-title-sub">
                        <i></i>
                        <span>查询分类</span>
                    </div>
                    <ul class="productTab">
                        <li :class="{ 'active': isActive == 1 }" @click="changeType(1)">
                            常见问题
                        </li>
                        <li :class="{ 'active': isActive == 2 }" @click="changeType(2)">
                            视频中心
                        </li>
                        <li :class="{ 'active': isActive == 3 }" @click="changeType(3)">
                            售后服务政策
                        </li>
                        <li :class="{ 'active': isActive == 4 }" @click="changeType(4)">
                            联系方式
                        </li>
                    </ul>
                </div>
                <div class="product-right">
                    <div class="page-title page-title-sub">
                        <i></i>
                        <span>{{ title }}</span>
                    </div>
                    <div class="supportRightMain">
                        <el-tabs v-if="isActive != 3" v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane v-for="item in supportArr" :label="item.title" :name="item.id"
                                :key="item.id"></el-tab-pane>
                        </el-tabs>
                        <template v-if="isActive == 1">
                            <div class="questionWrap" v-if="questionType && questionType.length > 0">
                                <ul class="questionType">
                                    <li v-for="item in questionType" :class="{ 'active': item.id == typeId }"
                                        @click="changeQuestionType(item.id)">
                                        {{ item.title }}
                                    </li>
                                </ul>
                                <ul v-if="questionList && questionList.length > 0" class="questionBox">
                                    <li v-for="(item, index) in questionList">
                                        <h2>
                                            {{ index + 1 }}、{{ item.q }}
                                        </h2>
                                        <p>答：{{ item.a }}</p>
                                    </li>
                                </ul>
                                <dl v-else class="defaultContent">
                                    <img src="../assets/img/kongbai.png" alt="">
                                    <b>暂无相关内容</b>
                                    <p>敬请期待</p>
                                </dl>
                            </div>
                            <dl v-else class="defaultContent">
                                <img src="../assets/img/kongbai.png" alt="">
                                <b>暂无相关内容</b>
                                <p>敬请期待</p>
                            </dl>
                        </template>
                        <template v-if="isActive == 2">
                            <ul class="videoList" v-if="videoList && videoList.length > 0 && videoList[0].url">
                                <li v-for="item in videoList" @click="showVideo(item)">
                                    <div class="coverBox" style="cursor: pointer;">
                                        <img class="coverImg" :src="getImagePath(item.coverImg)" alt="">
                                        <img class="startImg" src="../assets/img/start.png" alt="">
                                        <span class="duration">{{ item.duration }}</span>
                                    </div>
                                    <div class="videoInfo">
                                        <h3>
                                            {{ item.title }}
                                        </h3>
                                        <P>
                                            <b class="green" v-if="item.flag == 1">安装教学</b>
                                            <b class="blue" v-if="item.flag == 2">应用案例</b>
                                            <b class="orange" v-if="item.flag == 3">故障排查</b>
                                            <label>{{ item.date }}</label>
                                        </P>
                                    </div>
                                </li>
                            </ul>
                            <dl v-else class="defaultContent">
                                <img src="../assets/img/kongbai.png" alt="">
                                <b>暂无相关内容</b>
                                <p>敬请期待</p>
                            </dl>
                        </template>
                        <template v-if="isActive == 3">
                            <template v-if="supportArr.title">
                                <h2 class="policyTitle">{{ supportArr.title }}</h2>
                                <p class="policyContent">{{ supportArr.info }}</p>
                            </template>
                            <dl v-else class="defaultContent">
                                <img src="../assets/img/kongbai.png" alt="">
                                <b>暂无相关内容</b>
                                <p>敬请期待</p>
                            </dl>
                        </template>
                        <template v-if="isActive == 4">
                            <template v-if="supportArr.title">
                                <!-- <h2 class="policyTitle">{{ supportArr.title }}</h2> -->
                                <p>&nbsp;</p>
                                <p class="policyContent">座机电话：</p>
                                <p class="policyContent">售后服务邮箱地址：service@sforceauto.com</p>
                            </template>
                            <dl v-else class="defaultContent">
                                <img src="../assets/img/kongbai.png" alt="">
                                <b>暂无相关内容</b>
                                <p>敬请期待</p>
                            </dl>
                        </template>
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :title="videoInfo.title" :visible.sync="dialogVisible" width="65%" :before-close="handleClose">
            <video ref="vid" style="width: 100%;" autoplay :src="getImagePath(videoInfo.url)" controls controlslist="nodownload">
            </video>
        </el-dialog>




    </div>
</template>
    
<script>
import supportJson from '@/assets/data/support.json'
import Contact from '../components/Contact.vue'
export default {
    components: {
        Contact
    },
    data() {
        return {
            supportArr: [],
            isActive: 1,
            title: '常见问题',
            questionType: [],
            questionList: [],
            activeName: '1',
            typeId: 11,
            videoList: [],
            dialogVisible: false,
            videoInfo: {}

        };
    },
    watch: {
        '$route'(val, from) {
            if (val.query.type) {
                this.isActive = val.query.type ? val.query.type : 1
                this.title = this.isActive == 1 ? '常见问题' : this.isActive == 2 ? '视频中心' : this.isActive == 3 ? '售后服务政策' : '联系我们'
                this.supportArr = supportJson[`list${this.isActive}`]
                this.activeName =  this.supportArr && this.supportArr[0] ? this.supportArr[0].id : ''
                this.videoList = this.supportArr && this.supportArr[0] ? this.supportArr[0].videoList : []
                this.questionType = this.supportArr && this.supportArr[0] ? this.supportArr[0].questionType : ''
                this.typeId = this.questionType && this.questionType[0] ? this.questionType[0].id : ''
                this.questionList = this.questionType && this.questionType[0] ? this.questionType[0].questionList : ''
                this.$nextTick(() => {
                    window.scrollTo(0, 0)
                })

            }
        }
    },
    mounted() {
        this.isActive = this.$route.query.type ? this.$route.query.type : 1
        this.title = this.isActive == 1 ? '常见问题' : this.isActive == 2 ? '视频中心' : this.isActive == 3 ? '售后服务政策' : '联系我们'
        this.activeName = this.isActive == 1 ? '1' : this.isActive == 2 ? '5' : ''
        this.supportArr = supportJson[`list${this.isActive}`]
        this.activeName = this.supportArr && this.supportArr[0] ? this.supportArr[0].id : "1"
        this.videoList = this.supportArr && this.supportArr[0] ? this.supportArr[0].videoList : []
        this.questionType = this.supportArr[0].questionType
        this.questionType = this.supportArr[0].questionType
        this.typeId = this.questionType[0].id
        this.questionList = this.questionType[0].questionList
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },
    methods: {
        handleClose() {
            this.$refs.vid.pause()
            this.dialogVisible = false

        },
        showVideo(item) {
            console.log(item, 'showVideo--------->')
            this.dialogVisible = true
            this.videoInfo = item
        },

        // 切换问题类型
        changeQuestionType(id) {
            this.typeId = id
            this.questionType.forEach(item => {
                if (item.id == id) {
                    this.questionList = item.questionList
                }
            })

        },
        // tab切换
        handleClick(e) {
            this.activeName = e.name
            if (e.name < 5) {
                this.supportArr.forEach(item => {
                    if (item.id == e.name) {
                        this.questionType = item.questionType
                        if (this.questionType && this.questionType.length > 0) {
                            this.typeId = this.questionType[0].id
                            this.questionList = this.questionType[0].questionList
                        }
                    }
                })
            }
            else if (e.name >= 5) {
                this.supportArr.forEach(item => {
                    if (item.id == e.name) {
                        this.videoList = item.videoList
                    }
                })
            }
        },
        getImagePath(imageName) {
            if (imageName) {
                try {
                    return require(`@/assets${imageName}`);
                } catch (error) {
                    return imageName
                }
            }
        },
        // 切换类型
        changeType(type) {
            this.isActive = type
            this.type = type
            switch (type) {
                case 1:
                    this.supportArr = supportJson.list1
                    this.questionType = this.supportArr[0].questionType
                    this.typeId = this.questionType[0].id
                    this.questionList = this.questionType[0].questionList
                    this.title = '常见问题'
                    break;
                case 2:
                    this.supportArr = supportJson.list2
                    this.videoList = this.supportArr[0].videoList
                    this.title = '视频中心'
                    break;
                case 3:
                    this.supportArr = supportJson.list3
                    this.title = '售后服务政策'
                    break;
                case 4:
                    this.supportArr = supportJson.list4
                    this.title = '联系我们'
                    break;
            }
            this.activeName = this.supportArr && this.supportArr.length ? this.supportArr[0].id : ''




        },
        // 跳转详情
        toDetail(item, index) {
            // localStorage.setItem('productDetail', JSON.stringify(item))
            this.$router.push({
                path: '/productsDetail',
                query: {
                    id: item.id,
                    type: item.type,
                }
            })
        }

    }
};
</script>
    
<style scoped>
.videoList {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.videoList li {
    /* width: 33.33%; */
}
</style>
    


// WEBPACK FOOTER //
// src/views/Support.vue